import { notification } from '../../plugins/helpers'
import { AlertTypes } from '../../plugins/alerts_types'
export default {
  data: () => ({
    pontosVenda: [],
    carregandoPontosVenda: false,
    pontosVendaCarregados: false
  }),
  methods: {
    async carregarPontosVenda (params = {}) {
      try {
        this.carregandoPontosVenda = true
        this.pontosVendaCarregados = false
        this.pontosVenda.splice(0)

        const hierarquia = this.$session.get('hierarquia_comercial')

        const idEstruturaSelecionada = params.idEstruturaSelecionada || hierarquia?.estruturaComercialSelecionada?.idEstruturaComercial

        if (!idEstruturaSelecionada) {
          console.warn('Nenhum idEstruturaComercial encontrado. Lista de pontos de venda será deixada vazia.')
          this.pontosVenda = []
          return []
        }

        const requestParams = {
          ids: params.ids || '',
          searchText: params.searchText || '',
          gerenteNegocio: params.gerenteNegocio || hierarquia?.gerenteNegocioSelecionado?.codigoUsuario || '',
          idEstruturaSelecionada,
          isEntrandoFluxoVendas: params.isEntrandoFluxoVendas || false
        }

        const response = await this.$http.get('dynamic-selects/hierarquia_comercial/pontos_venda', { params: requestParams })

        if (response.data && response.data.items) {
          this.pontosVenda = response.data.items
          this.$session.set('pontos_venda', this.pontosVenda)

          const pontosDisponiveis = this.pontosVenda.filter(pv => String(pv.idPontoVenda) !== 'todos')
          console.info('Pontos de venda disponíveis:', pontosDisponiveis)

          if (pontosDisponiveis.length === 1) {
            this.selecionarPontoVenda(pontosDisponiveis[0])
          }
          this.pontosVendaCarregados = true
          return this.pontosVenda
        } else {
          this.pontosVenda = []
        }
      } catch (error) {
        console.error('Erro ao carregar os dados da hierarquia comercial:', error)
        const mensagemErro = error.response?.data?.error || null
        if (mensagemErro) {
          notification(AlertTypes.ERROR, mensagemErro)
        }
        this.pontosVenda = []
      } finally {
        this.carregandoPontosVenda = false
      }
    },
    selecionarPontoVenda (pontoVenda) {
      this.$session.set('id_ponto_venda', pontoVenda.idPontoVenda)
      this.$session.set('cd_ponto_venda', pontoVenda.codigoPontoVenda)
      this.$session.set('nm_ponto_venda', pontoVenda.nomeExibicaoPontoVenda)
      this.$session.set('data_inicio_vigencia', pontoVenda.dataInicioVigencia)
      this.$session.set('data_fim_vigencia', pontoVenda.dataFimVigencia)

      const comissionados = pontoVenda.comissionados || []
      this.$session.set('comissionados', comissionados)

      const idComissionados = comissionados.map(c => c.idComissionado)
      const todosMesmosIds = idComissionados.length > 0 && idComissionados.every(id => id === idComissionados[0])

      if (todosMesmosIds) {
        this.$session.set('id_comissionado_venda', idComissionados[0])
      } else {
        this.$session.set('id_comissionado_venda', -1)
      }
    }
  }
}
